import { Playlist } from "../../types/Playlist";
import { PlaylistType } from "../../types/PlaylistType";
import { trackDuration } from "../text-helper/text-helper";

export const getPlaylistDuration = (playlist?: Playlist) => {
    if (!playlist) {
        return '';
    }

    if (playlist.playlistType === PlaylistType.Albums) {
        return trackDuration(playlist.playlistItems?.reduce((accumulator, currentValue) =>
        accumulator + (currentValue.tracks?.reduce((acc, track) => acc + (track.duration ?? 0), 0) ?? 0), 0));
    }

    if (playlist.playlistType === PlaylistType.Tracks) {
        return trackDuration(playlist.playlistItems?.reduce((accumulator, currentValue) => accumulator + (currentValue.track?.duration ?? 0), 0));
    }

return '';
}